import React, { useCallback, useEffect, useState } from 'react';

import Thumbnail from './Thumbnail';
import TheoryThumbnail from './TheoryThumbnail';
import CompanionThumbnail from './CompanionThumbnail';
import EvilNoundleThumbnail from './EvilNoundleThumbnail';

const TokenThumbnail = ({ type, tokenId, size, footer }) => {
  switch (type) {
    case 'theory':
      return <TheoryThumbnail tokenId={tokenId} size={size} footer={footer} />;
    case 'companions':
      return <CompanionThumbnail tokenId={tokenId} size={size} footer={footer} />;
    case 'evil':
      return <EvilNoundleThumbnail tokenId={tokenId} size={size} footer={footer} />;
    default:
      return <Thumbnail tokenId={tokenId} size={size} footer={footer} />;
  }
};

const ThumbnailGrid = ({ noundles, frendles, ruggles }) => {

  return (
    <div className="d-flex flex-wrap justify-content-left">
      {noundles.map((tokenId) => (
        <div
          key={tokenId}
          className={`flex-shrink-0 p-1 m-2 rounded `}
        >
          <TokenThumbnail tokenId={tokenId} size={55} footer={false} />
        </div>
      ))}
      {frendles.map((tokenId) => (
        <div
          key={tokenId}
          className={`flex-shrink-0 p-1 m-2 rounded `}
        >
          <TokenThumbnail type={'companions'} tokenId={tokenId} size={55} footer={false} />
        </div>
      ))}
      {ruggles.map((tokenId) => (
        <div
          key={tokenId}
          className={`flex-shrink-0 p-1 m-2 rounded `}
        >
          <TokenThumbnail type={'evil'} tokenId={tokenId} size={55} footer={false} />
        </div>
      ))}
    </div>
  );
};

ThumbnailGrid.defaultProps = {
  noundles: [],
  frendles: [],
  ruggles: [],
};

export default ThumbnailGrid;
